
<br>
<br>
<button pButton [disabled]="!sample?.isOpen" type="button" label="Approve" (click)="approve(sample)"></button>
<button pButton [disabled]="!sample?.isOpen" type="button" label="Retest" (click)="retest(sample)" style="margin-left:20px;"></button>
<br>
<br>
<iframe [srcdoc]="reportFile" style="height:6000px;width:100%;border:none;overflow:hidden;"></iframe>